export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const USER = "user";
export const EMAIL = "email";
export const USERID = "userid";
export const USERNAME = "username";
export const AVATAR = "avatar";
export const avatarItem = localStorage.getItem(AVATAR);
